import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { SectionCReportLayerList } from '../components/Report/SectionCReportLayerList'

export const SectionCReportPageList = () => {
  return (
    <MasterLayout>
        <SectionCReportLayerList/>
    </MasterLayout>
  )
}
